const config = {
    defaults: {
        namespace: 'kitchenAppV2'
    }
};

export default config;
